import script from "./OrganizationSettingsView.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationSettingsView.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationSettingsView.vue?vue&type=style&index=0&id=222ff229&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-222ff229"]])

export default __exports__